import { ContexualKeywordIndicesResponseModel } from '../../../api/mentions/model/contexual-keyword-indices-response.model';
import { Clonable, basicClone } from '../../Basic/decorators/clone.decorator';

/**
 * A marker for where a keyword exists in a text body
 */
export class KeywordLocationModel {
    /** number of characters from start of mention body to start of keyword */
    @Clonable()
    characterStartPoint: number;
    /** number of characters from start of mention body to end of keyword */
    @Clonable()
    characterEndPoint: number;

    constructor(apiModel?: ContexualKeywordIndicesResponseModel) {
        if (apiModel) {
            this.characterStartPoint = apiModel.start;
            this.characterEndPoint = apiModel.end;
        }
    }

    toApiModel(): ContexualKeywordIndicesResponseModel {
        return {
            start: this.characterStartPoint,
            end: this.characterEndPoint
        };
    }

    clone(): KeywordLocationModel {
        return basicClone(this);
    }
}
